module.exports = __webpack_public_path__ + "static/media/logo-text.1b8984cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/logo-text.svg
// module id = 469
// module chunks = 0